module.exports = __webpack_public_path__ + "static/media/surface1.67ed7f48.svg";